// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'branch';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.333 3.156a2.125 2.125 0 1 0 4.25 0 2.125 2.125 0 0 0-4.25 0zm0 11.688a2.125 2.125 0 1 0 4.251 0 2.125 2.125 0 0 0-4.25 0zm7.084-9.563a2.125 2.125 0 1 0 4.249 0 2.125 2.125 0 0 0-4.25 0zm-4.959 0v7.438' />
    <path d='M12.542 7.406a2.833 2.833 0 0 1-2.834 2.834H7.583a2.125 2.125 0 0 0-2.125 2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
